import React, { useEffect, useState, useCallback } from 'react';
import PageHeader from 'Components/PageHeader';
import useEmployees from './useEmployees';
import EmployeeTableV2 from './EmployeeTableV2';
import EmployeeDrawerV2 from './EmployeeDrawerV2';
import {
  EmployeePageWrapperStyled,
  EmployeeTableWrapperStyled,
} from './EmployeeManagementV2.styles';



const EmployeeManagementV2 = () => {
  const {
    employees,
    pagination,
    loading,
    statusFilter,
    fetchPage,
    changeStatusFilter,
  } = useEmployees();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  useEffect(() => {
    fetchPage({ pageNo: 1 });
  }, []);

  const handleRowClick = useCallback((record) => {
    setSelectedEmployee(record);
    setDrawerOpen(true);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
    setSelectedEmployee(null);
  }, []);

  const handleSaveSuccess = useCallback(() => {
    fetchPage({
      pageNo: pagination.currentPage,
      pageSize: pagination.pageSize,
      complete: statusFilter,
    });
  }, [fetchPage, pagination.currentPage, pagination.pageSize, statusFilter]);

  const handlePageChange = useCallback(
    ({ pageNo, pageSize }) => {
      fetchPage({ pageNo, pageSize, complete: statusFilter });
    },
    [fetchPage, statusFilter],
  );

  return (
    <EmployeePageWrapperStyled>
      <PageHeader title="Manage Employees" />

      <EmployeeTableWrapperStyled>
        <EmployeeTableV2
          employees={employees}
          pagination={pagination}
          loading={loading}
          statusFilter={statusFilter}
          onPageChange={handlePageChange}
          onStatusFilterChange={changeStatusFilter}
          onRowClick={handleRowClick}
        />
      </EmployeeTableWrapperStyled>

      <EmployeeDrawerV2
        open={drawerOpen}
        employee={selectedEmployee}
        onClose={handleDrawerClose}
        onSaveSuccess={handleSaveSuccess}
      />
    </EmployeePageWrapperStyled>
  );
};

export default EmployeeManagementV2;
